/**
 * Editor + storefront visibility for popup schema steps.
 * Stored on step.popupSettings.isStepHidden.
 */

export function isStepHidden(step) {
  return step?.popupSettings?.isStepHidden === true;
}

export function isStepVisible(step) {
  return !isStepHidden(step);
}

export function setStepHidden(step, hidden) {
  if (!step) return step;
  step.popupSettings = step.popupSettings || {};
  if (hidden) {
    step.popupSettings.isStepHidden = true;
  } else {
    delete step.popupSettings.isStepHidden;
  }
  return step;
}

export function getVisibleSchemaStepIndices(popup) {
  const schema = Array.isArray(popup?.schema) ? popup.schema : [];
  return schema
    .map((step, index) => (!isStepHidden(step) ? index : null))
    .filter((index) => index != null);
}

export function hasVisibleSchemaSteps(popup) {
  return getVisibleSchemaStepIndices(popup).length > 0;
}

export function getFirstVisibleSchemaStepIndex(popup) {
  const indices = getVisibleSchemaStepIndices(popup);
  return indices.length ? indices[0] : null;
}
